export default function TextBox({
  data,
  containerStyle,
  oddStyle,
  evenStyle,
  boxStyle,
  titleStyle,
  imgStyle
}) {
  return (
    <div
      className={`boxes p-[2%_0%_1%_0%] flex justify-center flex-wrap gap-y-[19px] md:gap-y-[30px] gap-x-[2%] w-[85%] xs:w-full md:w-[85%] mx-auto ${containerStyle}`}
    >
      {data?.map(({ title, text, imgUrl }, index) => {
        return (
          <div
            className={`p-[10%] xs:p-[4%] ${
              boxStyle ? boxStyle : "xs:w-[40%] md:w-[26%] lg:w-[24%] w-full md:p-[3%]"
            }  ${index % 2 === 0 ? `${oddStyle}` : `${evenStyle}`}`}
          >
            {imgUrl ? <img className={imgStyle} src={imgUrl}></img> : null}

            <h3
              className={`${titleStyle ? titleStyle : "text-[20px] xl:text-[25px] font-bold leading-[24px] md:leading-[30px] pb-[4%] my-[0.67em]"}`}
            >
              {title}
            </h3>

            {text ? (
              <p className="text-[12px] md:text-[14px] mb-5 font-open">
                {text}
              </p>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
